import React, { useState, useEffect } from "react";
import config from "../../config";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

//components
import PageTitle from "../../components/PageTitle/PageTitle";
import { CircularProgress, TextField } from "@material-ui/core";
import Modal from "../modals/Modal";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  IconButton,
} from "@material-ui/core";
import SnackbarMessage from "../modals/SnackbarMessage";
import {
  CloudDownload as Download,
} from "@material-ui/icons";

// styles
import useStyles from "./styles";
import useStylesTable from "../products/styles";

const ProductsReport = () => {
  const classes = useStyles();
  const classesTable = useStylesTable();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const [products, setProducts] = useState([]);

  const closeModalLogin = e => {
    setShowModal(false);
  }

  useEffect(() => {
    fetchProducts();
  }, []);

  function currencyFormat(num) {
    return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

  const handleToClose = (event, reason) => {
    if ("clickaway" == reason) return;
    setShowSnackbar(false);
  };

  const fetchProducts = async () => {
    fetch(baseUrl + "productsReport",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data.status == "Ok") {
          setProducts(data.content);
        } else {
          setShowModal(true);
        }
        setIsLoading(false);
      }).catch(error => setIsLoading(false));
  }

  const onClickSave = () => {
    const pdf = new jsPDF();
    var totalPagesExp = '{total_pages_count_string}';

    pdf.text('Productos - KochulGym', 14, 20);

    pdf.autoTable({
      head: [['Producto', 'Categoría', 'Cantidad', 'Precio']],
      columns: [
        { dataKey: 'name', header: 'Producto' },
        { dataKey: 'category', header: 'Categoría' },
        { dataKey: 'stock', header: 'Cantidad' },
        { dataKey: 'price', header: 'Precio' },
      ],
      body: bodyRows(),
      startY: 30,
      didDrawPage: function (data) {
        // Footer
        var str = 'Página ' + pdf.internal.getNumberOfPages()
        // Total page number plugin only available in jspdf v1.0+
        if (typeof pdf.putTotalPages === 'function') {
          str = str + ' de ' + totalPagesExp
        }
        pdf.setFontSize(10);

        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = pdf.internal.pageSize
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
        pdf.text(str, data.settings.margin.left, pageHeight - 10)
      },
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof pdf.putTotalPages === 'function') {
      pdf.putTotalPages(totalPagesExp)
    }
    pdf.save("Productos.pdf");
  }

  function bodyRows() {
    var body = [];
    products.map(({ name, category, stock, salePrice }) => (
      body.push({
        name: name,
        category: category,
        stock: stock,
        price: currencyFormat(Number(salePrice)),
      })
    ));

    return body;
  }

  return (
    <>
      <div>
        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}

        <SnackbarMessage
          showSnackbar={showSnackbar}
          messageSnackbar={messageSnackbar}
          handleToClose={handleToClose}
          isError={errorSnackbar}
        />

        {isLoading ? (
          <CircularProgress size={26} className={classes.loginLoader} />
        ) : (
          <div style={{ height: "100%" }}>
            <PageTitle title="Productos" />

            <div className={classesTable.divCardSaleDos}>
              <div style={{ marginTop: "15px", marginBottom: "15px" }}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "25px", textAlign: "justify", backgroundColor: "#fff", borderRadius: "4px" }}>
                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "20%" }}>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "60%", height: "70px" }}>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", textAlign: "justify", width: "20%" }}>
                    <IconButton
                      onClick={onClickSave}
                      className={classes.enableButtonDate}
                    >
                      <Download style={{ marginRight: "8px" }} />
                      Descargar
                    </IconButton>
                  </div>
                </div>
              </div>

              <div style={{ alignItems: "center", justify: 'center', textAlign: "right", backgroundColor: "#fff", borderRadius: "4px", padding: '16px', width: "100%", height: "100%" }}>
                <Table style={{ marginBottom: "20px" }}>
                  <TableHead>
                    <TableRow className={classesTable.rootInvert} >
                      <TableCell size='small' padding='none' style={{ fontSize: "14px" }} >Producto</TableCell>
                      <TableCell size='small' padding='none' style={{ fontSize: "14px" }} >Categoría</TableCell>
                      <TableCell size='small' padding='none' style={{ fontSize: "14px" }} >Cantidad</TableCell>
                      <TableCell size='small' padding='none' style={{ fontSize: "14px" }} >Precio</TableCell>
                      {/*{keys.map(key => (
                            <TableCell key={key}>{key}</TableCell>
                          ))}*/}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.map(({ name, category, stock, salePrice }) => (
                      <TableRow style={{ height: "20px" }}>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{name}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{category}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{stock}</TableCell>
                        <TableCell className={classesTable.tableTextStyleInvert} size='small' padding='none' style={{ fontSize: "14px" }} >{currencyFormat(Number(salePrice))}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default ProductsReport;
